import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CLIENTTYPE_INIT_LOADING, CLIENTTYPE_INIT_SUCCESS, CLIENTTYPE_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [CLIENTTYPE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [CLIENTTYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [CLIENTTYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async clientTypeManagement({ commit, rootState }) {
    const apiUrl = rootState.app.menu.clientTypeManagement
    commit(CLIENTTYPE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CLIENTTYPE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CLIENTTYPE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
